// @ts-ignore
import { env } from './env';
export const FRONTEND_VERSION = '2.9.0';

const config = {
  BACKEND_URI: env.VITE_BACKEND_URI as string,
  AZURE_STORAGE_BASE_URL: env.VITE_AZURE_STORAGE_BASE_URL as string,
  MS_CLIENT_ID: env.VITE_MS_CLIENT_ID as string,

  ITEM_NAME_MAX_LENGTH: 200,
  MAX_FILES_UPLOAD: 200,
  MAX_FILE_SIZES_MB: {
    DOCUMENT_IMAGE: 5, // 5 MB
    DOCUMENT_CONTENT: 10, // 10 MB - matches backend MAX_FILE_SIZES_MB.DOCUMENT_CONTENT
    LITERATURE_PDF: 40, // 40 MB - matches backend MAX_FILE_SIZES_MB.LITERATURE_PDF
    IMPORT_FILE: 100, // 100 MB
    LITERATURE_CSV: 5, // 5 MB - matches backend MAX_FILE_SIZES_MB.LITERATURE_CSV
    DOCUMENT_IMPORT_FILE: 40, // 40 MB
  },
  MAX_TOTAL_UPLOAD_SIZE: 500, // 500 MB
};

export default config;
